import { render, staticRenderFns } from "./sor-group.vue?vue&type=template&id=6ac2d4d4&"
import script from "./sor-group.vue?vue&type=script&lang=js&"
export * from "./sor-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports